import { Link } from "react-router-dom";
import "./SupplierCenteralFooter.css";

export { SupplierCenteralFooter };

function SupplierCenteralFooter() {

  return (
    <footer className="footer">
      <div className="top-footer-body d-flex position-relative">
        <div className="footer-box">
          <Link to="/supplier-centeral-home" className="d-inline-flex"><img src="/images/logo.svg" alt="" /></Link>
          <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
          <div className="social-media-sec">
            <h3>STAY UP TO DATE</h3>
            <ul className="position-relative d-flex align-center">
              <li><a href="#" className="position-relative d-flex align-center justify-center"><img src="/images/facebook.svg" alt="" /></a></li>
              <li><a href="#" className="position-relative d-flex align-center justify-center"><img src="/images/x-icon.svg" alt="" /></a></li>
              <li><a href="#" className="position-relative d-flex align-center justify-center"><img src="/images/linkedin.svg" alt="" /></a></li>
              <li><a href="#" className="position-relative d-flex align-center justify-center"><img src="/images/pinterest.svg" alt="" /></a></li>
              <li><a href="#" className="position-relative d-flex align-center justify-center"><img src="/images/youtube.svg" alt="" /></a></li>
            </ul>
          </div>
        </div>
        <div className="footer-box">
          <h3>About Octas</h3>
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">About Us</a></li>
            <li><a href="#">Winning Together with Octas</a></li>
            <li><a href="#">Our Community</a></li>
            <li><a href="#">Sustainability at Octas</a></li>
            <li><a href="#">Contact Us</a></li>
          </ul>
        </div>
        <div className="footer-box">
          <h3>Octas Vendor Central</h3>
          <ul>
            <li><a href="#">How to become a supplier</a></li>
            <li><a href="#">Trading with us</a></li>
            <li><a href="#">Vendor Information</a></li>
            <li><a href="#">Coles Vendor Portal</a></li>
          </ul>
        </div>
        <div className="footer-box last-f-box">
          <h2>Need to get in touch with our team?</h2>
          <a href="#" className="footer-contact-btn d-flex align-center justify-center position-relative">Contact Us <span className="material-symbols-outlined">arrow_outward</span></a>
          <div className="help-center-text d-flex justify-center position-relative">24/7 <a href="">Help Center</a></div>
          <form>
            <div className="form-group m-0 d-flex position-relative">
              <input type="text" className="form-control" placeholder="Enter your email" />
              <button type="button" className="footer-form-btn d-flex align-center justify-center">
                <span className="material-symbols-outlined">send</span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <hr />
      <div className="bottom-footer-body d-flex position-relative justify-between align-center">
        <p className="d-flex align-center">© 2024 | All rights reserved <a href="#">Octa Devs</a></p>
        <ul className="d-flex">
          <li><a href="#">Terms &amp; Conditions</a></li>
          <li><a href="#">Privacy Policy</a></li>
        </ul>
      </div>
    </footer>
  );
}